import { SearchFilterOption } from "../../../shared/components/search-bar/search-filter/search-filter.component";
import { SearchInputOption } from "../../../shared/components/search-bar/search-input/search-input.component";
import { yesNoOptions } from "../../../shared/constants/components";
import { UserInfo, UserRights, UserTypes } from "../../../shared/types/user-info";
import { User } from "./user.type";

//#region Search Filter Options

export const getUserSearchFilterOptions = (
  user: UserInfo,
  config?: {
    shown?: string[];
    hidden?: string[];
  },
): SearchFilterOption<User>[] => {
  const { shown, hidden } = config || {};

  return (
    [
      { value: "firstName", label: "First Name" },
      { value: "lastName", label: "Last Name" },
      { value: "email", label: "Email" },
      {
        id: "partner",
        value: "partner",
        label: "Partner",
        filterByProperty: [{ partner: { name: true } }, { company: { partner: { name: true } } }],
        hidden: !user.isGlobal(),
      },
      {
        id: "company.name",
        value: "company.name",
        label: "Company",
        filterByProperty: { company: { name: true } },
        hidden: user.isCompanyOrViewAsCompany({ ignoreIfMultiCompanies: true }),
      },
      {
        id: "type",
        value: "type",
        label: "Type",
        inputType: "dropdown",
        options: [...userTypes].filter((type) => {
          if (!user.isGlobal() && type.value === UserTypes.Global) {
            return false;
          }
          if (user.isCompany() && type.value === UserTypes.Partner) {
            return false;
          }
          return true;
        }),
        condition: "$eq",
      },
      {
        value: "confirmed",
        label: "Confirmed",
        inputType: "dropdown",
        options: [...yesNoOptions],
        condition: "$eq",
        hidden: !user.hasRight(["admin"]),
      },
      {
        id: "activated",
        value: "activated",
        label: "Activated",
        inputType: "dropdown",
        options: [...yesNoOptions],
        condition: "$eq",
        hidden: !user.isGlobalAdmin(),
      },
      {
        id: "deleted",
        value: "deleted",
        label: "Deleted",
        inputType: "dropdown",
        options: [...yesNoOptions],
        condition: "$eq",
        hidden: !user.isGlobal(),
      },
    ] as SearchFilterOption<User>[]
  ).filter((opt) => (shown ? shown.includes(opt.value) : true) && (hidden ? !hidden.includes(opt.value) : true));
};

//#endregion

//#region Search Input Options

export const userRights: SearchInputOption[] = [
  { value: "admin", label: UserRights.Admin },
  { value: "manager", label: UserRights.Manager },
  { value: "viewer", label: UserRights.Viewer },
];

export const userTypes: SearchInputOption[] = [
  { value: "global", label: UserTypes.Global },
  { value: "partner", label: UserTypes.Partner },
  { value: "company", label: UserTypes.Company },
];

export const userConfirmation: SearchInputOption[] = [
  { value: 1, label: "Yes" },
  { value: 0, label: "No" },
];

export const userActivation: SearchInputOption[] = [
  { value: 1, label: "Yes" },
  { value: 0, label: "No" },
];

export const userDeleted: SearchInputOption[] = [
  { value: 1, label: "Yes" },
  { value: 0, label: "No" },
];

//#endregion
